var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveNotificationsBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "29px",
    viewBox: "0 0 24 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1582.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active-notifications-bell",
    transform: "translate(1582.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C12.0852224,2 12.1701891,2.0011418 12.2548863,2.00341122 C11.7526717,2.72030634 11.3833483,3.53660435 11.1798808,4.41640474 C7.81796518,4.99799462 5.25,7.99186314 5.25,11.5877402 L5.25,11.5877402 L5.25,21.2857143 L19.5,21.2857143 L19.5008652,12.8387213 C20.2527649,12.6744629 20.9594817,12.3893574 21.5996376,12.0047825 L21.5999794,21.6363828 L22.7999897,21.6363828 C23.4635454,21.6363828 24,22.1849258 24,22.8636172 C24,23.5423086 23.463597,24.0909043 22.7999897,24.0909043 L22.7999897,24.0909043 L16.7999897,24.0909043 C16.7999897,26.7982871 14.6472105,29 12,29 C9.35278952,29 7.20001031,26.7982871 7.20001031,24.090957 L7.20001031,24.090957 L1.20001031,24.090957 C0.536403011,24.090957 0,23.5423613 0,22.8636699 C0,22.1849785 0.536403011,21.6363828 1.20001031,21.6363828 L1.20001031,21.6363828 L2.40002062,21.6363828 L2.40002062,11.8181914 C2.40002062,6.40469141 6.70681654,2 12,2 Z M14.25,24.3714286 L9.75,24.3714286 C9.75,25.6477289 10.7590933,26.6857143 11.9999758,26.6857143 C13.2408584,26.6857143 14.2499517,25.6477289 14.25,24.3714286 L14.25,24.3714286 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EC0000",
    cx: 18,
    cy: 6,
    r: 6
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNotificationsBell);
export default __webpack_public_path__ + "static/media/active-notifications-bell.65285cbe.svg";
export { ForwardRef as ReactComponent };